module.exports = __webpack_public_path__ + "static/media/lumin.bad92427.png";